import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button, Modal, Form, Badge, Row, Col, Table, Alert } from "react-bootstrap";
import Interweave from "interweave";
import {
  Paper,
  Grid,
  TextField,
  FormControl,
  Card,
  List,
  ListItem,
  ListItemText,
  CardMedia,
  CardContent,
  Select,
  InputLabel,
  MenuItem,
  Chip,
  Typography,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import Masonry from "react-masonry-css";
import DocumentIcon from "@material-ui/icons/Description";
import { format, parse } from "date-fns";
import * as Admin from "../store/ducks/admin.duck";
import * as Reference from "../store/ducks/reference.duck";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../_metronic/_assets/css/app.css";
import "../../_metronic/_assets/css/app2.css";

export function BookingWeek(props) {
  // console.log('Appointments Props:', props)
  const dispatch = useDispatch();
  var [sessionType, setSessionType] = useState("P0102");
  const [bookingDuration, setBookingDuration] = useState("60");
  const role = useSelector((state) => state.auth.roleDesc);

  var [bookingLocation, setBookingLocation] = useState("Centre");
  useEffect(() => {
    dispatch(
      Admin.actions.fetchMatching({
        providertype: props.providerType,
        invite: false,
        availabilitytype:
          props.program === 1
            ? "PerinatalGriefLoss"
            : props.specialistType === "nthqldphn"
              ? "NthQLDPHNExisting"
              : props.specialistType === "centralisedservice"
                ? "CentralisedService"
                : props.paymentType === "NDIS" || props.paymentType === "Contract" || props.paymentType === "Island"
                  ? "NDISContractEAP"
                  : props.paymentType === "EAP"
                    ? "EAPExisting"
                    : props.providerType === "Supervision"
                      ? "Supervision"
                      : "Existing",
      }),
    );
  }, [dispatch, props.providerType, props.paymentType]);
  useEffect(() => {
    setSinglePsychologist();
  });
  useEffect(() => {
    dispatch(Reference.actions.fetchTimeZone());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchSundayThisWeek());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchMatchingCSProviders({ sessionType: sessionType, duration: bookingDuration ? bookingDuration : "60" }));
  }, [dispatch, sessionType, bookingDuration]);
  useEffect(() => {
    dispatch(Reference.actions.fetchAreasOfInterest({ providerType: "ALL", centralisedservice: true }));
  }, [dispatch]);
  useEffect(() => {
    if (props.specialistType === "centralisedservice") {
      dispatch(Admin.actions.fetchCMSDocumentLink({ contentName: "Remote Psychiatry Appointment" }));
    }
  }, [props.specialistType]);

  const startingSunday = useSelector((state) => state.reference.SundayThisWeek);
  const matching = useSelector((state) => state.admin.Matching);
  const matchingAvailability = useSelector((state) => state.admin.MatchingAvailability);
  const csProviders = useSelector((state) => state.admin.MatchingCSProviders);
  const timeZone = useSelector((state) => state.reference.TimeZone);
  const areasOfInterestReference = useSelector((state) => state.reference.AreasOfInterest);
  const areasOfInterest = areasOfInterestReference.filter((aoi) => aoi.providertype === "Psychologist" && aoi.focusAreaIndex && !aoi.program);
  const remotePsychiatryDocumentLink = useSelector((state) => state.admin.CMSDocumentLink);

  var [currentPsychologistID, setcurrentPsychologistID] = useState(props.clientPsychologistProviderID || null);
  var [currentPsychiatristID, setcurrentPsychiatristID] = useState(props.clientPsychiatristProviderID || null);
  var [currentHourlyRate, setcurrentHourlyRate] = useState();
  var [currentPsychologistFullname, setcurrentPsychologistFullname] = useState();
  var [currentWaitingRoomURL, setcurrentWaitingRoomURL] = useState();
  var [currentPsychologistTimeZone, setcurrentPsychologistTimeZone] = useState();
  var [displayTZ, setDisplayTZ] = useState("client");
  var [psychologistSet, setPsychologistSet] = useState(false);

  var [providerBioFullName, setProviderBioFullName] = useState();
  var [providerBioBio, setProviderBioBio] = useState();
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [selectedProviderType, setSelectedProviderType] = useState("Psychologist");
  const [showNewBooking, setShowNewBooking] = useState(false);
  const [showPsychiatristInfo, setShowPsychiatristInfo] = useState(false);
  const [newBookingProps, setNewBookingProps] = useState({});
  const [showBookingError, setShowBookingError] = useState(false);
  const [showCSProvider, setShowCSProvider] = useState(false);
  const [showProviderBio, setShowProviderBio] = useState(false);
  const [selectedPsychologist, setSelectedPsychologist] = useState(null);
  const [existingProviderNoAvailability, setExistingProviderNoAvailability] = useState("");

  const linkStyle = {
    color: "#0056b3",
    textDecoration: "none",
  };

  useEffect(() => {
    if (props.specialistType === "centralisedservice") {
      if (!csProviders || csProviders.length === 0) return;
      const csProvider = csProviders.find((p) => p.id === props.clientProviderID) || null;
      // setSelectedPsychologist(csProvider);
    } else {
      if (!matching || matching.length === 0) return;
      const provider = matching.find((p) => p.id === props.clientProviderID) || null;
      // Check for future bookings - props.nextBooking should be null if no future bookings or an ID if there is a future booking
      if (props.nextBooking) {
        setExistingProviderNoAvailability("Warning: Cancel future bookings prior to changing providers.");
      } else {
        if (!provider) {
          setExistingProviderNoAvailability("Warning: Existing Provider has no future availability");
        } else {
          setExistingProviderNoAvailability("");
        }
      }
      setSelectedPsychologist(provider);
      handleMatchingAutocompleteChange(provider);
    }
  }, [csProviders, matching, props.clientProviderID]);
  // console.log("clientProviderID:", props.clientProviderID);

  const isMobile = useMediaQuery("(max-width: 760px)");

  const moreProviderBio = (fullName, bio) => {
    setProviderBioFullName(fullName);
    setProviderBioBio(bio);
    setShowProviderBio(true);
  };

  // clientProviderID

  // Filter CS Providers based on selected areas of interest and providertype
  const filteredProviders = csProviders.filter((provider) => {
    // Filter by area of interest
    const matchesArea = selectedAreas.length === 0 ? true : provider.areasOfInterest.some((issue) => selectedAreas.some((sel) => sel.issue === issue));

    // Filter by provider type
    const matchesType =
      selectedProviderType === ""
        ? true
        : selectedProviderType === "Psychologist"
          ? provider.providertype === "Psychologist" || provider.providertype === "Clinical"
          : provider.providertype === selectedProviderType;

    return matchesArea && matchesType;
  });

  // Updated the Filtered Providers to put the current psychologist at the top of the list
  const sortedProviders = [...filteredProviders].sort((a, b) => {
    const aIsCurrent = a.id === (selectedProviderType === "Psychiatrist" ? currentPsychiatristID : currentPsychologistID);
    const bIsCurrent = b.id === (selectedProviderType === "Psychiatrist" ? currentPsychiatristID : currentPsychologistID);
    if (aIsCurrent && !bIsCurrent) return -1;
    if (!aIsCurrent && bIsCurrent) return 1;
    return 0;
  });

  // Blob setup for psychologist photos
  const containerName = `psychologists`;
  const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME || "";

  // in psychologist mode, we do not select one, but set it up from props
  const setSinglePsychologist = () => {
    if (props.mode === "psychologist" && props.psychologistID && !psychologistSet) {
      // setSinglePsychologist
      // Determine providertype
      if (props.providerType === "GP") {
        setcurrentPsychologistID(props.gpID);
        setcurrentPsychologistFullname(props.gpFullname);
        setcurrentWaitingRoomURL(props.gpcurrentWaitingRoomURL);
        // These two are not in use - both TBA
        setcurrentHourlyRate(props.currentHourlyRate);
        setcurrentPsychologistTimeZone(props.psychologistTZ);
        dispatch(
          Admin.actions.fetchMatchingAvailability({
            psychologistID: props.gpID,
            userTZ: displayTZ === "psychologist" ? props.psychologistTZ : props.clientTZ,
            availabilityType:
              props.program === 1
                ? "PerinatalGriefLoss"
                : props.specialistType === "nthqldphn"
                  ? "NthQLDPHNExisting"
                  : props.specialistType === "centralisedservice"
                    ? "CentralisedService"
                    : props.providerType === "Supervision"
                      ? "Supervision"
                      : props.paymentType === "EAP"
                        ? "EAPExisting"
                        : props.paymentType === "NDIS" || props.paymentType === "Contract" || props.paymentType === "Island"
                          ? "NDISContractEAP"
                          : "Existing",
            invite: false,
          }),
        );
      } else {
        setcurrentPsychologistID(props.psychologistID);
        setcurrentPsychologistFullname(props.psychologistFullname);
        setcurrentWaitingRoomURL(props.currentWaitingRoomURL);
        // These two are not in use - both TBA
        setcurrentHourlyRate(props.currentHourlyRate);
        setcurrentPsychologistTimeZone(props.psychologistTZ);
        dispatch(
          Admin.actions.fetchMatchingAvailability({
            psychologistID: props.psychologistID,
            userTZ: displayTZ === "psychologist" ? props.psychologistTZ : props.clientTZ,
            availabilityType:
              props.program === 1
                ? "PerinatalGriefLoss"
                : props.specialistType === "nthqldphn"
                  ? "NthQLDPHNExisting"
                  : props.specialistType === "centralisedservice"
                    ? "CentralisedService"
                    : props.paymentType === "NDIS" || props.paymentType === "Contract" || props.paymentType === "Island"
                      ? "NDISContractEAP"
                      : props.paymentType === "EAP"
                        ? "EAPExisting"
                        : props.providerType === "Supervision"
                          ? "Supervision"
                          : "Existing",
            invite: false,
          }),
        );
      }
      //
      setPsychologistSet(true);
    }

    if (props.mode === "client" && props.psychologistID && !psychologistSet) {
      // Client Setting;
      if (props.providerType === "GP") {
        setcurrentPsychologistID(props.gpID);
        setcurrentPsychologistFullname(props.gpFullname);
        setcurrentWaitingRoomURL(props.gpcurrentWaitingRoomURL);
        // These two are not in use - both TBA
        setcurrentHourlyRate(props.currentHourlyRate);
        setcurrentPsychologistTimeZone(props.psychologistTZ);
        dispatch(
          Admin.actions.fetchMatchingAvailability({
            psychologistID: props.gpID,
            userTZ: displayTZ === "client" ? props.psychologistTZ : props.clientTZ,
            availabilityType: "Existing",
            invite: props.inviteType && props.inviteType === "client" ? true : false,
          }),
        );
      } else {
        setcurrentPsychologistID(props.psychologistID);
        setcurrentPsychologistFullname(props.psychologistFullname);
        setcurrentWaitingRoomURL(props.currentWaitingRoomURL);
        // These two are not in use - both TBA
        setcurrentHourlyRate(props.currentHourlyRate);
        setcurrentPsychologistTimeZone(props.psychologistTZ);
        dispatch(
          Admin.actions.fetchMatchingAvailability({
            psychologistID: props.psychologistID,
            userTZ: displayTZ === "client" ? props.clientTZ : props.psychologistTZ,
            availabilityType:
              props.program === 1
                ? "PerinatalGriefLoss"
                : props.specialistType === "nthqldphn"
                  ? "NthQLDPHNExisting"
                  : props.specialistType === "centralisedservice"
                    ? "CentralisedService"
                    : props.paymentType === "NDIS" || props.paymentType === "Contract" || props.paymentType === "Island"
                      ? "NDISContractEAP"
                      : props.paymentType === "EAP"
                        ? "EAPExisting"
                        : props.providerType === "Supervision"
                          ? "Supervision"
                          : "Existing",
            invite: props.inviteType && props.inviteType === "client" ? true : false,
          }),
        );
      }
      //
      setDisplayTZ("client");
      setPsychologistSet(true);
      // console.log('setSinglePsychologist')
    }
  };

  // in admin mode, we handle the selection of psychologists
  function handleMatchingAutocompleteChange(newValue) {
    // console.log("Firing handleMatchingAutocompleteChange with newValue:", newValue);
    if (newValue === 0) {
      // Clear selection
      setSelectedPsychologist(null);
      // setcurrentProviderType(null);
      setcurrentPsychologistID(null);
      setcurrentHourlyRate(null);
      setcurrentPsychologistFullname(null);
      setcurrentPsychologistTimeZone(null);
      setcurrentWaitingRoomURL(null);
    } else {
      if (newValue) {
        setSelectedPsychologist(newValue);
        setcurrentPsychologistID(newValue.id);
        setcurrentPsychologistFullname(newValue.firstname + " " + newValue.surname);
        setcurrentHourlyRate(newValue.hourlyrate);
        // setcurrentProviderType(newValue.providertype);
        setcurrentWaitingRoomURL(newValue.waitingroomurl);
        setcurrentPsychologistTimeZone(newValue.timezone);
        if (newValue.providertype === "Psychiatrist") {
          setShowPsychiatristInfo(true);
        } else {
          setShowPsychiatristInfo(false);
        }
        // Need to set session type based on selected psychologist providertype - if clinical psychologist, session type might differ
        if (newValue.providertype === "Clinical") {
          // Determine session type and update
          console.log("Updating session type for Clinical psychologist - existing session type:", sessionType);
          if (sessionType === "P0101") {
            setSessionType("P0201"); // Update session type for Clinical psychologist
            console.log("Updated session type for Clinical psychologist - new session type:", "P0201");
          }
          if (sessionType === "P0102") {
            setSessionType("P0202"); // Update session type for Clinical psychologist
            console.log("Updated session type for Clinical psychologist - new session type:", "P0202");
          }
          if (sessionType === "P0103") {
            setSessionType("P0203"); // Update session type for Clinical psychologist
            console.log("Updated session type for Clinical psychologist - new session type:", "P0203");
          }
          if (sessionType === "S0108") {
            setSessionType("S0208"); // Update session type for Clinical psychologist
            console.log("Updated session type for Clinical psychologist - new session type:", "S0208");
          }
        }

        dispatch(
          Admin.actions.fetchMatchingAvailability({
            psychologistID: newValue.id,
            userTZ: displayTZ === "psychologist" ? newValue.timezone : props.clientTZ,
            availabilityType:
              props.program === 1
                ? "PerinatalGriefLoss"
                : props.specialistType === "nthqldphn"
                  ? "NthQLDPHNExisting"
                  : props.specialistType === "centralisedservice"
                    ? "CentralisedService"
                    : props.paymentType === "NDIS" || props.paymentType === "Contract" || props.paymentType === "Island"
                      ? "NDISContractEAP"
                      : props.paymentType === "EAP"
                        ? "EAPExisting"
                        : props.providerType === "Supervision"
                          ? "Supervision"
                          : "Existing",
            invite: false,
            sessionType: props.specialistType === "centralisedservice" ? sessionType : "Normal",
            duration: props.specialistType === "centralisedservice" ? bookingDuration : "60",
          }),
        );
      }
      setShowCSProvider(false);
    }
  }

  function SessionTypeUpdate(value) {
    // Ok session type has updated
    // Need to update parameter
    setSessionType(value);
    // And call fetchMatchingAvailability if psychologist id is populated with new session type (messy isn't it)
    if (currentPsychologistID) {
      dispatch(
        Admin.actions.fetchMatchingAvailability({
          psychologistID: currentPsychologistID,
          userTZ: displayTZ === "psychologist" ? currentPsychologistTimeZone : props.clientTZ,
          availabilityType:
            props.program === 1
              ? "PerinatalGriefLoss"
              : props.specialistType === "nthqldphn"
                ? "NthQLDPHNExisting"
                : props.specialistType === "centralisedservice"
                  ? "CentralisedService"
                  : props.paymentType === "NDIS" || props.paymentType === "Contract" || props.paymentType === "Island"
                    ? "NDISContractEAP"
                    : props.paymentType === "EAP"
                      ? "EAPExisting"
                      : props.providerType === "Supervision"
                        ? "Supervision"
                        : "Existing",
          invite: false,
          sessionType: value,
          duration: bookingDuration ? bookingDuration : "60",
        }),
      );
    }
  }

  function BookingDurationUpdate(value) {
    setBookingDuration(value);
    if (currentPsychologistID) {
      dispatch(
        Admin.actions.fetchMatchingAvailability({
          psychologistID: currentPsychologistID,
          userTZ: displayTZ === "psychologist" ? currentPsychologistTimeZone : props.clientTZ,
          availabilityType:
            props.program === 1
              ? "PerinatalGriefLoss"
              : props.specialistType === "nthqldphn"
                ? "NthQLDPHNExisting"
                : props.specialistType === "centralisedservice"
                  ? "CentralisedService"
                  : props.paymentType === "NDIS" || props.paymentType === "Contract" || props.paymentType === "Island"
                    ? "NDISContractEAP"
                    : props.paymentType === "EAP"
                      ? "EAPExisting"
                      : props.providerType === "Supervision"
                        ? "Supervision"
                        : "Existing",
          invite: false,
          sessionType: props.specialistType === "centralisedservice" ? sessionType : "Normal",
          duration: value ? value : "60",
        }),
      );
    }
  }

  function changeDisplayTZ(value) {
    if (props.mode === "client") {
      currentPsychologistID &&
        dispatch(
          Admin.actions.fetchMatchingAvailability({
            psychologistID: currentPsychologistID,
            userTZ: value === "client" ? currentPsychologistTimeZone : props.clientTZ,
            availabilityType:
              props.program === 1
                ? "PerinatalGriefLoss"
                : props.specialistType === "nthqldphn"
                  ? "NthQLDPHNExisting"
                  : props.specialistType === "centralisedservice"
                    ? "CentralisedService"
                    : props.paymentType === "NDIS" || props.paymentType === "Contract" || props.paymentType === "Island"
                      ? "NDISContractEAP"
                      : props.paymentType === "EAP"
                        ? "EAPExisting"
                        : props.providerType === "Supervision"
                          ? "Supervision"
                          : "Existing",
            invite: false,
          }),
        );
    } else {
      currentPsychologistID &&
        dispatch(
          Admin.actions.fetchMatchingAvailability({
            psychologistID: currentPsychologistID,
            userTZ: value === "psychologist" ? currentPsychologistTimeZone : props.clientTZ,
            availabilityType:
              props.program === 1
                ? "PerinatalGriefLoss"
                : props.specialistType === "nthqldphn"
                  ? "NthQLDPHNExisting"
                  : props.specialistType === "centralisedservice"
                    ? "CentralisedService"
                    : props.paymentType === "NDIS" || props.paymentType === "Contract" || props.paymentType === "Island"
                      ? "NDISContractEAP"
                      : props.paymentType === "EAP"
                        ? "EAPExisting"
                        : props.providerType === "Supervision"
                          ? "Supervision"
                          : "Existing",
            invite: false,
          }),
        );
    }
    setDisplayTZ(value);
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      padding: 4,
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    dayCol: {
      padding: 2,
    },
    media: {
      height: 200, // or whatever height you want
      objectFit: "cover",
    },
    autocompletePopper: {
      zIndex: 3000, // higher than Bootstrap modal
    },
    modalOverride: {
      overflow: "visible", // prevent clipping inside modal
    },
  }));

  var [startDate, setStartDate] = useState(new Date(startingSunday));
  var [endDate, setEndDate] = useState(new Date(startingSunday));
  var [nextWeek, setNextWeek] = useState("");
  var [prevWeek, setPrevWeek] = useState("");
  var [weekdays, setWeekDays] = useState([]);

  function makeWeek(newDateStr) {
    var thisStartDate = new Date(newDateStr);
    setStartDate(new Date(newDateStr));

    var endDate = new Date(thisStartDate);
    endDate.setDate(endDate.getDate() + 6);
    setEndDate(new Date(endDate));

    var tempDays = [];
    // set start date one day back so we can
    thisStartDate.setDate(thisStartDate.getDate());

    var i = 1;
    while (i <= 7) {
      tempDays.push(new Date(thisStartDate.setDate(thisStartDate.getDate() + 1)));
      i++;
    }

    var backWeek = new Date(newDateStr);
    backWeek.setDate(backWeek.getDate() - 7);
    setPrevWeek(formatDateString(backWeek));

    var nextWeek = new Date(newDateStr);
    nextWeek.setDate(nextWeek.getDate() + 7);
    setNextWeek(formatDateString(nextWeek));

    setWeekDays(tempDays);
  }

  function formatDateString(dateInput) {
    const o_date = new Intl.DateTimeFormat("au");
    const f_date = (m_ca, m_it) => Object({ ...m_ca, [m_it.type]: m_it.value });
    const m_date = o_date.formatToParts(dateInput).reduce(f_date, {});
    return m_date.year + "-" + (m_date.month < 10 ? "0" + m_date.month : m_date.month) + "-" + m_date.day;
  }

  useEffect(() => {
    initWeek();
  });

  function initWeek() {
    if (startingSunday.length && weekdays.length === 0) {
      makeWeek(startingSunday);
    }
  }

  const classes = useStyles();

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  function getDateRangeLabel() {
    if (startDate.getYear() === endDate.getYear()) {
      return (
        <>
          {startDate ? startDate.getDate() : ""}-{startDate ? endDate.getDate() : ""} {startDate ? monthNames[endDate.getMonth()] : ""}
        </>
      );
    } else {
      return (
        <>
          {startDate ? startDate.getDate() : ""} {startDate ? monthNames[startDate.getMonth()] : ""} - {startDate ? endDate.getDate() : ""}{" "}
          {startDate ? monthNames[endDate.getMonth()] : ""}
        </>
      );
    }
  }

  function handleCSProviderClose() {
    setShowCSProvider(false);
  }

  const startNewBooking = (booking) => {
    setShowNewBooking(true);
    setNewBookingProps({
      mode: booking.mode,
      day: booking.day,
      hour: booking.hour,
      psychologistID: booking.psychologistID,
      paymentType: booking.paymentType,
      bookingType: booking.bookingType,
      clientID: booking.clientID,
      duration: booking.duration,
      bookingLocation: booking.bookingLocation,
      sessionType: booking.sessionType,
      specialistType: booking.specialistType,
    });
  };

  function durationTypeLookUp(sessionType) {
    var durationType = "60";
    switch (sessionType) {
      case "P0101":
        // Handle P0101 session type
        durationType = "60";
        break;
      case "P0201":
        // Handle P0201 session type
        durationType = "60";
        break;
      case "P0102":
        // Handle P0102 session type
        durationType = "60";
        break;
      case "P0202":
        // Handle P0202 session type
        durationType = "60";
        break;
      case "P0304":
        // Handle P0304 session type
        durationType = "60";
        break;
      case "P0305":
        // Handle P0305 session type
        durationType = "60";
        break;
      case "P0107":
        // Handle P0107 session type
        durationType = "15";
        break;
      case "P0207":
        // Handle P0207 session type
        durationType = "15";
        break;
      case "P0103":
      case "P0203":
      case "P0306":
      case "S0108":
      case "S0208":
      case "S0309":
        // Defined from the UI
        durationType = bookingDuration ? bookingDuration : "15";
        break;
      default:
        durationType = "60";
        break;
    }
    return durationType;
  }

  const sessionTypeDescriptor = (sessionType) => {
    var descriptor = "";
    switch (sessionType) {
      case "P0101":
        descriptor = "Psychology Diagnostic Assessment & Report";
        break;
      case "P0102":
        descriptor = "Psychology Therapy Session";
        break;
      case "P0103":
        descriptor = "Primary Psychology case conference";
        break;
      case "S0108":
        descriptor = "Case Review Meeting (No Client) (SCC)";
        break;
      case "P0201":
        descriptor = "Psychology Diagnostic Assessment & Report";
        break;
      case "P0202":
        descriptor = "Psychology Therapy Session";
        break;
      case "P0203":
        descriptor = "Primary Psychology case conference";
        break;
      case "P0208":
        descriptor = "Case Review Meeting (No Client) (SCC)";
        break;
      case "P0304":
        descriptor = "Primary Psychiatry Assessment and Report";
        break;
      case "P0305":
        descriptor = "Primary Psychiatry Follow-up Review";
        break;
      case "P0306":
        descriptor = "Primary Psychiatry Case Conference";
        break;
      case "S0309":
        descriptor = "Secondary Psychiatry Case Conference";
        break;
      default:
        descriptor = sessionType;
        break;
    }
    return descriptor;
  };

  const saveAppointment = (newBookingProps) => {
    // Need to consider this further - need to support removing appointments as well
    // console.log(newBookingProps);
    var newbookingdate = newBookingProps.day + newBookingProps.hour.substring(0, 5);
    if (newBookingProps.mode === "client") {
      // Check if date within 48 hours as clients cannot book Psychologists within next 48 hours
      var twoDaysInFuture = new Date();
      twoDaysInFuture.setHours(twoDaysInFuture.getHours() + 48);
      var booking_date = new Date(newbookingdate);
      if (booking_date.getTime() < twoDaysInFuture.getTime()) {
        // Bookings must be at least 48 hours in advance
        // console.log('Too Soon');
        setShowNewBooking(false);
        setShowBookingError(true);
      } else {
        dispatch(
          Admin.actions.bookAppointment({
            timezone: displayTZ === "psychologist" ? currentPsychologistTimeZone : props.clientTZ,
            newbookingdate: newbookingdate,
            day: newBookingProps.day,
            hour: newBookingProps.hour,
            clientID: newBookingProps.clientID,
            psychologistID: newBookingProps.psychologistID,
            psychologistname: newBookingProps.psychologistname,
            waitingRoomURL: newBookingProps.waitingRoomURL,
            clientFullName: newBookingProps.clientFullName,
            clientFirstName: newBookingProps.clientFirstName,
            clientPreferredName: newBookingProps.clientPreferredName,
            clientEmail: newBookingProps.clientEmail,
            paymentType: newBookingProps.paymentType,
            bookingType: newBookingProps.bookingType,
            refreshPayload: { key: "client", id: newBookingProps.clientID },
          }),
        );
        setShowNewBooking(false);
        props.setShowAppointment && props.setShowAppointment(false);
        props.setMakeBooking(false);
      }
      // Update future booking status
      dispatch(
        Admin.actions.fetchClientFutureBookingStatus({
          providertype: props.providerType,
        }),
      );
    } else {
      // console.log(props)
      dispatch(
        Admin.actions.bookAppointment({
          timezone: displayTZ === "psychologist" ? currentPsychologistTimeZone : props.clientTZ,
          newbookingdate: newbookingdate,
          day: newBookingProps.day,
          hour: newBookingProps.hour,
          clientID: newBookingProps.clientID,
          psychologistID: newBookingProps.psychologistID,
          psychologistname: newBookingProps.psychologistname,
          waitingRoomURL: newBookingProps.waitingRoomURL,
          clientFullName: newBookingProps.clientFullName,
          clientFirstName: newBookingProps.clientFirstName,
          clientPreferredName: newBookingProps.clientPreferredName,
          clientEmail: newBookingProps.clientEmail,
          paymentType: newBookingProps.paymentType,
          bookingType: newBookingProps.bookingType,
          bookingCode: props.specialistType === "Standard" ? "Normal" : newBookingProps.sessionType,
          bookingLocation: newBookingProps.bookingLocation === "Centre" ? "Centre" : "Remote",
          duration: newBookingProps.duration,
          refreshPayload: {
            key: props.specialistType !== "Standard" ? "centralisedservice" : "psychologist",
            id: newBookingProps.psychologistID,
          },
        }),
      );
      setShowNewBooking(false);
      props.setShowAppointment && props.setShowAppointment(false);
    }
  };

  if (props.specialistType === "centralisedservice" && !showCSProvider) {
    setShowCSProvider(true);
  }

  return (
    <>
      {!showCSProvider ? (
        <div className={classes.root}>
          <Grid container spacing={1}>
            {props.mode === "admin" ? (
              <>
                <Grid item xs={6} md={6}>
                  <InputLabel>
                    {props.providerType === "GP" ? (
                      <>GP Selection</>
                    ) : (
                      <>{props.providerType === "Financial" ? <>Financial Counsellor Selection</> : <>Provider Selection</>}</>
                    )}
                  </InputLabel>
                  <Autocomplete
                    id="MatchingID"
                    variant="outlined"
                    options={matching}
                    disabled={props.nextBooking}
                    getOptionLabel={(option) => option.oneline || ""}
                    value={selectedPsychologist}
                    onChange={(event, newValue) => {
                      handleMatchingAutocompleteChange(newValue);
                    }}
                    style={{ fullWidth: true, display: "flex", wrap: "nowrap" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        type="text"
                        variant="outlined"
                        margin="dense"
                        name="MatchingSelector"
                        multiline={true}
                        style={{
                          backgroundColor: "white",
                          margin: 0,
                          padding: 0,
                        }}
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6} md={6} style={{ display: "flex", alignItems: "center" }}>
                  {existingProviderNoAvailability ? (
                    <Typography variant="h6" style={{ color: "red", whiteSpace: "nowrap", marginLeft: "10px", marginTop: "18px" }}>
                      {existingProviderNoAvailability}
                    </Typography>
                  ) : null}
                </Grid>
              </>
            ) : null}

            {props.specialistType === "centralisedservice" ? (
              <Grid item xs={2} md={2}>
                <Form.Group>
                  <InputLabel>Location</InputLabel>
                  <Form.Control
                    as="select"
                    defaultValue={bookingLocation}
                    onChange={(event) => setBookingLocation(event.target.value)}
                    disabled={sessionType.substring(0, 1) === "S" ? true : false}
                  >
                    <option value="Centre">At Centre</option>
                    <option value="Remote">Remote</option>
                  </Form.Control>
                </Form.Group>
              </Grid>
            ) : null}
            {props.specialistType === "centralisedservice" ? (
              <Grid item xs={1} md={1}>
                <Button variant="primary" size="sm" style={{ marginTop: 20 }} onClick={() => setShowCSProvider(true)}>
                  New Provider
                </Button>
              </Grid>
            ) : null}
          </Grid>
          {showPsychiatristInfo ? (
            <Card
              style={{
                marginTop: 5,
                marginBottom: 5,
                backgroundColor: "rgba(255, 235, 59, 0.3)",
              }}
            >
              <CardContent>
                <Typography component="p" style={{ fontWeight: 600, color: "#000" }}>
                  <span style={{ fontWeight: 600 }}>Please note:</span> All Psychiatry sessions must take place at the Centre and a brief handover to a Centre
                  staff member must occur at completion.
                </Typography>
              </CardContent>
            </Card>
          ) : null}
          <Grid container direction="row" justifyContent="space-between" spacing={2} style={{ marginTop: 8 }}>
            <Grid item md={5}>
              <Button
                variant="light"
                onClick={() => {
                  makeWeek(startingSunday);
                }}
                style={{ marginRight: 10 }}
              >
                Today
              </Button>
              <Button
                variant="light"
                onClick={() => {
                  makeWeek(prevWeek);
                }}
                style={{ marginRight: 10 }}
                alt="here"
              >
                {" "}
                &lt;{" "}
              </Button>
              <Button
                variant="light"
                onClick={() => {
                  makeWeek(nextWeek);
                }}
                style={{ marginRight: 10 }}
              >
                {" "}
                &gt;{" "}
              </Button>
              {getDateRangeLabel()}
            </Grid>
            {props.mode !== "client" ? (
              <Grid item md={7}>
                {currentPsychologistTimeZone !== props.clientTZ ? (
                  <>
                    <Button
                      variant="light"
                      className={displayTZ === "psychologist" ? "selected-tz" : null}
                      onClick={() => {
                        changeDisplayTZ("psychologist");
                      }}
                      style={{ marginRight: 10 }}
                    >
                      {props.providerType === "GP" ? <>GP:</> : <>{props.providerType === "Financial" ? <>Fin:</> : <>Psy:</>}</>}
                      {currentPsychologistTimeZone && timeZone.find((row) => row.systemName === currentPsychologistTimeZone).name}
                    </Button>
                    <Button
                      variant="light"
                      className={displayTZ === "client" ? "selected-tz" : null}
                      onClick={() => {
                        changeDisplayTZ("client");
                      }}
                      style={{ marginRight: 10 }}
                    >
                      Client: {props.clientTZ && timeZone.find((row) => row.systemName === props.clientTZ).name}
                    </Button>
                  </>
                ) : (
                  <Button variant="light" className="selected-tz" style={{ marginRight: 10 }}>
                    Psy/Client: {currentPsychologistTimeZone && timeZone.find((row) => row.systemName === currentPsychologistTimeZone).name}
                  </Button>
                )}
              </Grid>
            ) : (
              <>
                <Grid item md={5}>
                  {props.providerType === "GP" ? (
                    <h4>Availability for GP: {currentPsychologistFullname}</h4>
                  ) : (
                    <>
                      {props.providerType === "Financial" ? (
                        <h4>Availability for Financial Counsellor : {currentPsychologistFullname}</h4>
                      ) : (
                        <>
                          {props.providerType === "Supervision" ? (
                            <h4>Availability for Supervising Psychologist : {currentPsychologistFullname}</h4>
                          ) : (
                            <h4>Availability for Psychologist : {currentPsychologistFullname}</h4>
                          )}
                        </>
                      )}
                    </>
                  )}
                </Grid>
                <Grid item md={2} style={{ textAlign: "right" }}>
                  <Button variant="light" onClick={() => props.setMakeBooking(false)} style={{ textAlign: "right", marginRight: 10 }}>
                    Cancel
                  </Button>
                </Grid>
                <Grid item md={12} style={{ textAlign: "center", fontWeight: 600 }}>
                  <p>
                    If your psychologist does not have any availability showing but you are an existing client, they will book you in. Please send them a
                    message and if you need further help, please contact Rural Heath Connect admin via the phone numbers on our website
                  </p>
                </Grid>
              </>
            )}
          </Grid>
          {/* if it is a centralised service and no session type selected - don't dislay  */}
          {props.specialistType === "centralisedservice" && sessionType === "" ? (
            <div style={{ marginTop: 20, textAlign: "center", fontWeight: 600 }}>Please select a session type to view availability.</div>
          ) : (
            <Grid container direction="row" spacing={2}>
              {weekdays.map((thisDay) => (
                <Grid item xs className={classes.dayCol} key={thisDay}>
                  <Paper className={classes.paper}>
                    <BookingDay
                      matchingAvailability={matchingAvailability}
                      mode={props.mode}
                      day={thisDay}
                      clientID={props.clientID}
                      clientFullName={props.clientfullname}
                      bookingType={props.bookingType}
                      paymentType={props.paymentType}
                      currentPsychologistID={currentPsychologistID ? currentPsychologistID : 0}
                      startNewBooking={startNewBooking}
                      specialistType={props.specialistType}
                      sessionType={sessionType}
                      bookingLocation={bookingLocation}
                    />
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
        </div>
      ) : (
        <>
          {!selectedPsychologist || selectedPsychologist === null ? (
            <>
              <Typography variant="h6" style={{ marginBottom: 16 }}>
                Select Provider Type, review available providers, and click "Select" to commence creating a booking.
              </Typography>
              <Autocomplete
                id="ProviderTypeSelection"
                options={["Psychologist", "Psychiatrist"]}
                value={selectedProviderType}
                disableClearable
                onChange={(e, newValue) => {
                  setSelectedProviderType(newValue || "");
                  switch (newValue) {
                    case "Psychologist":
                      SessionTypeUpdate("P0102");
                      break;
                    case "Clinical Psychologist":
                      SessionTypeUpdate("P0202");
                      break;
                    case "Psychiatrist":
                      SessionTypeUpdate("P0304");
                      break;
                    default:
                      SessionTypeUpdate("P0102");
                      break;
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Provider Type Selection" variant="outlined" margin="dense" fullWidth style={{ backgroundColor: "white" }} />
                )}
                style={{ marginBottom: 20, width: 250 }}
              />
              <Typography variant="h6" style={{ marginBottom: 16 }}>
                Select Session Type to view availability.
              </Typography>
              <Form.Group>
                <InputLabel>Session Type</InputLabel>
                <Form.Control as="select" value={sessionType} onChange={(event) => SessionTypeUpdate(event.target.value)} style={{ width: "500px" }}>
                  <option value="" disabled hidden>
                    -- Please select a session type to view Available Bookings --
                  </option>
                  {selectedProviderType === "Psychologist" ? (
                    <>
                      <option value="P0101">Psychology Diagnostic Assessment & Report (One-off Appt)</option>
                      <option value="P0102">Psychology Therapy Session</option>
                      <option value="P0103">Primary Psychology case conference</option>
                      <option value="S0108">Case Review Meeting (No Client) (SCC)</option>
                      {/* <option value="P0107">Primary	After hours consult</option> */}
                    </>
                  ) : null}
                  {selectedProviderType === "Psychiatrist" ? (
                    <>
                      <option value="P0304">Primary Psychiatry Assessment and Report</option>
                      <option value="P0305">Primary Psychiatry Follow-up Review</option>
                      <option value="P0306">Primary Psychiatry Case Conference</option>
                      <option value="S0309">Secondary Psychiatry Case Conference</option>
                    </>
                  ) : null}
                </Form.Control>
              </Form.Group>
              {sessionType === "S0309" ||
              sessionType === "S0208" ||
              sessionType === "S0108" ||
              sessionType === "P0103" ||
              sessionType === "P0203" ||
              sessionType === "P0306" ? (
                <Form.Group>
                  <InputLabel>Duration</InputLabel>
                  <Form.Control
                    as="select"
                    defaultValue={bookingDuration}
                    onChange={(event) => BookingDurationUpdate(event.target.value)}
                    style={{ width: "150px" }}
                  >
                    <option value="15">15 minutes</option>
                    <option value="30">30 minutes</option>
                    <option value="45">45 minutes</option>
                    <option value="60">60 minutes</option>
                    <option value="75">75 minutes</option>
                    <option value="90">90 minutes</option>
                    <option value="105">105 minutes</option>
                    <option value="120">120 minutes</option>
                  </Form.Control>
                </Form.Group>
              ) : null}
              {selectedProviderType === "Psychologist" || selectedProviderType === "Clinical Psychologist" ? (
                <>
                  <Typography variant="h6" style={{ marginBottom: 16 }}>
                    Enter relevant Areas of Interest for the Client
                  </Typography>
                  <Autocomplete
                    id="AreasOfInterestSelection"
                    multiple
                    options={areasOfInterest}
                    getOptionLabel={(option) => option.issue}
                    getOptionSelected={(option, value) => option.id === value.id}
                    value={selectedAreas}
                    onChange={(e, newValue) => setSelectedAreas(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Filter by Areas of Interest"
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        style={{ backgroundColor: "white" }}
                      />
                    )}
                    fullWidth
                    style={{ marginBottom: 20 }}
                  />
                </>
              ) : null}

              <hr />
              <Grid
                item
                md={12}
                style={{
                  height: 710,
                  width: "100%",
                  overflowY: "scroll",
                  paddingLeft: 20,
                  backgroundColor: "rgb(255,255,255)",
                }}
              >
                <Masonry breakpointCols={isMobile ? 1 : 3} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                  {sortedProviders &&
                    sortedProviders.map((row, index) => {
                      const isCurrentProvider = row.id === (selectedProviderType === "Psychiatrist" ? currentPsychiatristID : currentPsychologistID);
                      return (
                        <Card
                          className={classes.root}
                          variant="outlined"
                          key={index}
                          style={{
                            border: isCurrentProvider ? "3px solid #ffc107" : undefined,
                            boxShadow: isCurrentProvider ? "0 0 10px rgba(255,193,7,0.4)" : undefined,
                          }}
                        >
                          <CardMedia
                            className={classes.media}
                            image={`https://${storageAccountName}.blob.core.windows.net/${containerName}/${row.imageURL}`}
                            title="Psychologist"
                          />
                          <CardContent>
                            <Grid container justifyContent="space-between">
                              <Grid item sm={12}>
                                <Typography variant="h5" component="h3">
                                  {row.fullname}{" "}
                                  {isCurrentProvider && (
                                    <Badge
                                      variant="warning"
                                      style={{
                                        fontSize: "0.75rem",
                                        verticalAlign: "middle",
                                        marginLeft: 6,
                                      }}
                                    >
                                      Latest Booking
                                    </Badge>
                                  )}
                                </Typography>
                                <Typography variant="subtitle1">{row.providerdescription}</Typography>
                                <Typography variant="subtitle2">
                                  {row.appointmentType === "BOTH"
                                    ? "Appointments are via Video or Phone call"
                                    : row.appointmentType === "PHONE"
                                      ? "Appointments are via Phone call"
                                      : "Appointments are via Video call"}
                                </Typography>
                              </Grid>
                              <Grid item sm={12}>
                                <Typography variant="subtitle1" style={{ fontWeight: 600, paddingTop: 20 }} gutterBottom>
                                  Appointments Available on these dates:
                                </Typography>
                                {row.nextAvailable && row.nextAvailable.length > 0 ? (
                                  <List dense sx={{ paddingTop: 0, paddingBottom: 0 }}>
                                    {row.nextAvailable.map((next, index) => (
                                      <ListItem key={index} disableGutters sx={{ paddingY: 0.25 }}>
                                        <ListItemText
                                          primary={`• ${format(parse(next, "dd/MM/yyyy", new Date()), "EEE, dd MMM, yyyy")}`}
                                          primaryTypographyProps={{
                                            variant: "body2",
                                          }}
                                        />
                                      </ListItem>
                                    ))}
                                  </List>
                                ) : (
                                  <Typography variant="body2" color="textSecondary">
                                    No upcoming appointments.
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                            <Typography className={classes.pos} color="textSecondary">
                              <br />
                            </Typography>
                            <Grid container>
                              <Typography variant="body2" component="p">
                                <Interweave content={row.bio.substring(0, 250)} />
                                {row.bio.length > 250 && (
                                  <>
                                    ...
                                    <Badge
                                      variant="secondary"
                                      onClick={() => moreProviderBio(row.fullname, row.bio)}
                                      style={{
                                        marginRight: 5,
                                        cursor: "pointer",
                                      }}
                                    >
                                      more
                                    </Badge>
                                  </>
                                )}
                              </Typography>
                            </Grid>
                            <Grid container direction="column" style={{ marginTop: 16 }}>
                              <Typography variant="subtitle2" color="textSecondary" style={{ marginBottom: 6, fontWeight: 600 }}>
                                Areas of Interest
                              </Typography>

                              <Grid container>
                                {row.areasOfInterest.map((item) => (
                                  <Chip key={item} size="small" label={item} color="primary" variant="outlined" style={{ margin: 4 }} />
                                ))}
                              </Grid>
                            </Grid>
                            <Grid container direction="column" style={{ marginTop: 12 }}>
                              <Typography variant="subtitle2" color="textSecondary" style={{ marginBottom: 6, fontWeight: 600 }}>
                                Therapy Types
                              </Typography>

                              <Grid container>
                                {row.therapyTypes?.map((item) => (
                                  <Chip key={item} size="small" label={item} color="secondary" style={{ margin: 4 }} />
                                ))}
                              </Grid>
                            </Grid>
                            <br />
                            <Button onClick={() => handleMatchingAutocompleteChange(row)}>Select</Button>
                          </CardContent>
                        </Card>
                      );
                    })}
                </Masonry>
              </Grid>
            </>
          ) : (
            <>
              <Row>
                <Col md={6}>
                  <Grid
                    item
                    md={12}
                    style={{
                      height: 710,
                      width: "100%",
                      overflowY: "scroll",
                      paddingLeft: 20,
                      backgroundColor: "rgb(255,255,255)",
                    }}
                  >
                    <Masonry breakpointCols={1} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                      <Card className={classes.root} variant="outlined">
                        <CardMedia
                          className={classes.media}
                          image={`https://${storageAccountName}.blob.core.windows.net/${containerName}/${selectedPsychologist.imageURL}`}
                          title="Psychologist"
                        />
                        <CardContent>
                          <Grid container justifyContent="space-between">
                            <Grid item sm={12}>
                              <Typography variant="h5" component="h3">
                                {selectedPsychologist.fullname}
                              </Typography>
                              <Typography variant="subtitle1">{selectedPsychologist.providerdescription}</Typography>
                              <Typography variant="subtitle2">
                                {selectedPsychologist.appointmentType === "BOTH"
                                  ? "Appointments are via Video or Phone call"
                                  : selectedPsychologist.appointmentType === "PHONE"
                                    ? "Appointments are via Phone call"
                                    : "Appointments are via Video call"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography className={classes.pos} color="textSecondary">
                            <br />
                          </Typography>
                          <Grid container>
                            <Typography variant="body2" component="p">
                              <Interweave content={selectedPsychologist.bio.substring(0, 250)} />
                              {selectedPsychologist.bio.length > 250 && (
                                <>
                                  ...
                                  <Badge
                                    variant="secondary"
                                    onClick={() => moreProviderBio(selectedPsychologist.fullname, selectedPsychologist.bio)}
                                    style={{
                                      marginRight: 5,
                                      cursor: "pointer",
                                    }}
                                  >
                                    more
                                  </Badge>
                                </>
                              )}
                            </Typography>
                          </Grid>
                          <Grid container direction="column" style={{ marginTop: 16 }}>
                            <Typography variant="subtitle2" color="textSecondary" style={{ marginBottom: 6, fontWeight: 600 }}>
                              Areas of Interest
                            </Typography>
                            <Grid container>
                              {selectedPsychologist.areasOfInterest.map((item) => (
                                <Chip key={item} size="small" label={item} color="primary" variant="outlined" style={{ margin: 4 }} />
                              ))}
                            </Grid>
                          </Grid>
                          <Grid container direction="column" style={{ marginTop: 12 }}>
                            <Typography variant="subtitle2" color="textSecondary" style={{ marginBottom: 6, fontWeight: 600 }}>
                              Therapy Types
                            </Typography>
                            <Grid container>
                              {selectedPsychologist.therapyTypes?.map((item) => (
                                <Chip key={item} size="small" label={item} color="secondary" style={{ margin: 4 }} />
                              ))}
                            </Grid>
                          </Grid>
                          <br />
                        </CardContent>
                      </Card>
                    </Masonry>
                  </Grid>
                </Col>
                <Col md={6}>
                  <h5 style={{ marginBottom: "30px" }}>Session Category - {sessionTypeDescriptor(sessionType)}</h5>
                  <Form.Group>
                    <h5>Location</h5>
                    <Form.Control
                      as="select"
                      defaultValue={bookingLocation}
                      onChange={(event) => setBookingLocation(event.target.value)}
                      disabled={sessionType.substring(0, 1) === "S" ? true : false}
                    >
                      <option value="Centre">At Centre</option>
                      <option value="Remote">Remote</option>
                    </Form.Control>
                  </Form.Group>
                  {bookingLocation === "Remote" && selectedPsychologist.providertype === "Psychiatrist" ? (
                    <Alert
                      variant="info"
                      style={{
                        display:
                          remotePsychiatryDocumentLink && remotePsychiatryDocumentLink.image_url && remotePsychiatryDocumentLink.image_url.length > 0
                            ? "block"
                            : "none",
                        backgroundColor: "#e6f4ff",
                        borderColor: "#b3e0ff",
                      }}
                    >
                      <Alert.Heading style={{ color: "#007acc", fontSize: "1.0rem", marginBottom: "0.7rem" }}>
                        Please complete the below form and upload it to "Files" to proceed with this remote appointment
                      </Alert.Heading>
                      <ul style={{ listStyleType: "none", paddingLeft: 0, margin: 0 }}>
                        <li style={{ marginTop: 4 }}>
                          <DocumentIcon style={{ marginRight: 10, color: linkStyle.color }} />
                          <a href={`https://files.ruralhealthconnect.com.au/fileStoreRHC/${remotePsychiatryDocumentLink.image_url}`} download style={linkStyle}>
                            Remote Psychiatry Appointment Form
                          </a>
                        </li>
                      </ul>
                    </Alert>
                  ) : null}
                  {sessionType !== "" ? (
                    <>
                      <h5>Available Bookings:</h5>
                      <div className="register-table-responsive">
                        <Table bordered hover style={{ backgroundColor: "white" }} className="register-table">
                          <thead className="register-thead">
                            <tr className="register-tr">
                              <th>Date</th>
                              <th>From</th>
                              <th>To</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody className="register-tbody">
                            {matchingAvailability?.slice(0, 20).map((row, index) => (
                              <tr key={row.id ?? index} className="register-tr">
                                <td>{format(new Date(row.fromDate), "EEE, dd MMM, yyyy")}</td>
                                <td>{format(new Date(row.fromDate), "HH:mm aa")}</td>
                                <td>{format(new Date(row.toDate), "HH:mm aa")}</td>
                                <td>
                                  <Button
                                    onClick={() =>
                                      startNewBooking({
                                        mode: props.mode,
                                        day: format(new Date(row.fromDate), "yyyy-MM-dd") + "T",
                                        hour: format(new Date(row.fromDate), "HH:mm"),
                                        psychologistid: currentPsychologistID,
                                        paymentType: props.paymentType,
                                        // Booking Type is VIDEO if psychiatrist - otherwise whatever is stored with the client or default to VIDEO
                                        bookingType:
                                          selectedPsychologist.providertype === "Psychiatrist" && bookingLocation === "Remote"
                                            ? "VIDEO"
                                            : (props.bookingType ?? "VIDEO"),
                                        clientID: props.clientID,
                                        duration: durationTypeLookUp(sessionType),
                                        bookingLocation: bookingLocation,
                                        sessionType: sessionType,
                                        specialistType: props.specialistType,
                                      })
                                    }
                                  >
                                    Book
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </>
                  ) : null}
                  <Grid container style={{ marginTop: 20 }}>
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="primary"
                        onClick={() => handleMatchingAutocompleteChange(0)}
                        style={{
                          fontWeight: "bold",
                          padding: "18px 24px", // increased vertical and horizontal padding
                          textTransform: "uppercase",
                          borderRadius: 8,
                          boxShadow: "0 4px 12px rgba(0,0,0,0.2)", // subtle shadow for depth
                        }}
                      >
                        Change Providers or Session Type
                      </Button>
                    </Grid>
                  </Grid>
                </Col>
              </Row>
            </>
          )}
        </>
      )}

      <Modal show={showNewBooking} onHide={() => setShowNewBooking(false)} dialogClassName="new-bookingDialog-modal" centered>
        <Modal.Header closeButton className="new-booking-modal">
          <Modal.Title>New Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container spacing={2}>
            <Grid item md={3} xs={6}>
              Psychologist:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {currentPsychologistFullname}
            </Grid>
            <Grid item md={3} xs={6}>
              Client:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {props.clientFullname}
            </Grid>
            <Grid item md={3} xs={6}>
              Date:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {newBookingProps.day && newBookingProps.day.substring(0, 10)}
            </Grid>
            <Grid item md={3} xs={6}>
              Time:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {newBookingProps.hour && newBookingProps.hour.substring(0, 5)}
            </Grid>
            <Grid item md={3} xs={6}>
              Booking Type:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {newBookingProps.bookingType && newBookingProps.bookingType === "FACE"
                ? "Face to Face"
                : newBookingProps.bookingType === "PHONE"
                  ? "Phone Call"
                  : "Video Call"}
            </Grid>
            <Grid item md={3} xs={6}>
              Duration:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {newBookingProps.duration} minutes
            </Grid>
            {newBookingProps.specialistType === "centralisedservice" ? (
              <>
                <Grid item md={3} xs={6}>
                  Session Type:
                </Grid>
                <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                  {newBookingProps.sessionType === "P0101"
                    ? "P0101	Psychology Diagnostic Assessment & Report (One-off Appt)"
                    : newBookingProps.sessionType === "P0201"
                      ? "P0201	Psychology Diagnostic Assessment & Report (One-off Appt)"
                      : newBookingProps.sessionType === "P0102"
                        ? "P0102	Psychology Therapy Session"
                        : newBookingProps.sessionType === "P0202"
                          ? "P0202	Psychology Therapy Session"
                          : newBookingProps.sessionType === "P0103"
                            ? "P0103	Primary	Psychology case conference"
                            : newBookingProps.sessionType === "P0203"
                              ? "P0203	Primary	Psychology case conference"
                              : newBookingProps.sessionType === "P0304"
                                ? "P0304	Primary	Psychiatry Assessment and Report"
                                : newBookingProps.sessionType === "P0305"
                                  ? "P0305	Primary	Psychiatry Follow-up Review"
                                  : newBookingProps.sessionType === "P0306"
                                    ? "P0306	Primary	Psychiatry case conference"
                                    : newBookingProps.sessionType === "S0108"
                                      ? "S0108 Case Review Meeting (No Client) (SCC)"
                                      : newBookingProps.sessionType === "S0208"
                                        ? "S0208 Case Review Meeting (No Client) (SCC)"
                                        : newBookingProps.sessionType === "S0309"
                                          ? "S0309 Secondary Psychiatry case conference"
                                          : null}
                </Grid>
              </>
            ) : null}
            {newBookingProps.specialistType === "centralisedservice" ? (
              <>
                <Grid item md={3} xs={6}>
                  Location:
                </Grid>
                <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                  {newBookingProps.bookingLocation === "Remote"
                    ? "Via Video or Phone Call with Provider"
                    : newBookingProps.bookingLocation === "Centre"
                      ? "At Centre"
                      : null}
                </Grid>
              </>
            ) : null}

            {newBookingProps.mode !== "client" && newBookingProps.specialistType !== "centralisedservice" ? (
              <>
                <Grid item md={3} xs={6}>
                  Cost:
                </Grid>
                <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                  {currentHourlyRate}
                </Grid>
                <Grid item md={3} xs={6}>
                  Payment Type:
                </Grid>
                <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                  {props.paymentType}
                </Grid>
              </>
            ) : null}
            {/* <Grid item md={3} xs={6}>
              Session URL:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {currentWaitingRoomURL}
            </Grid> */}
          </Grid>
        </Modal.Body>
        <Modal.Footer className="new-booking-modal">
          <Button variant="secondary" onClick={() => setShowNewBooking(false)} className="lightButtonOutlinedLarge">
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() =>
              saveAppointment({
                ...newBookingProps,
                psychologistID: currentPsychologistID,
                psychologistname: currentPsychologistFullname,
                paymentType: props.paymentType,
                waitingRoomURL: currentWaitingRoomURL,
                clientFirstName: props.clientFirstName,
                clientPreferredName: props.clientPreferredName,
                clientEmail: props.clientEmail,
              })
            }
          >
            Book Now
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showBookingError} onHide={() => setShowBookingError(false)} dialogClassName="new-bookingDialog-modal" centered>
        <Modal.Header closeButton className="new-booking-modal">
          <Modal.Title>Warning - Booking Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container spacing={2}>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              You are trying to alter a booking within the 48 hour window. This may incur fees. Please message your provider via the Send Message to your
              Provider Button
            </Grid>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="new-booking-modal">
          <Button variant="secondary" onClick={() => setShowBookingError(false)} className="lightButtonOutlinedLarge">
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showProviderBio} onHide={() => setShowProviderBio(false)} dialogClassName="invite-modal">
        <Modal.Header closeButton className="invite-modal">
          <Modal.Title>{providerBioFullName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="invite-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container>
            <Typography variant="body2" component="p">
              <Interweave content={providerBioBio} />
            </Typography>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="invite-modal">
          <Button variant="secondary" onClick={() => setShowProviderBio(false)} className="lightButtonOutlinedLarge">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function getActualStartTimeMinutes(props, thisHour, currentDate) {
  // Determine actual time for saving appointment
  const founditem =
    props.matchingAvailability &&
    props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 16) === currentDate + thisHour.substring(0, 5));
  return founditem.fromDate.toString().substring(11, 16);
}

function getActualStartTime(props, thisHour, currentDate) {
  // Determine actual time for saving appointment
  const founditem = props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 13) === currentDate + thisHour.substring(0, 2));
  return founditem.fromDate.toString().substring(11, 16);
}

function getActualStartTimeDisplayMinutes(props, thisHour, currentDate) {
  // Determine descriptor to show in calendar
  const founditem = props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 16) === currentDate + thisHour.substring(0, 5));
  // console.log('Found Item:', founditem)
  if (props.mode === "client") {
    return "Book Session @" + founditem.fromDate.toString().substring(11, 16);
  } else {
    return founditem.fromDate.toString().substring(11, 16);
  }
}

function getActualStartTimeDisplay(props, thisHour, currentDate) {
  // Determine descriptor to show in calendar
  const founditem = props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 13) === currentDate + thisHour.substring(0, 2));
  if (props.mode === "client") {
    return "Book Session @" + founditem.fromDate.toString().substring(11, 16);
  } else {
    return founditem.fromDate.toString().substring(11, 16);
  }
}

function getAvailabilityTypeForTimeBlockMinutes(props, thisHour, currentDate) {
  // Determine availability type of slot - only used in the Face to Face to change the booking button colour
  const founditem = props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 16) === currentDate + thisHour.substring(0, 5));
  // console.log('Found Item:', founditem)
  return founditem.availabilityType;
}

function getAvailabilityTypeForTimeBlock(props, thisHour, currentDate) {
  // console.log("Props:", props);
  // console.log('This Hour:', thisHour)
  // console.log('Current Date:', currentDate)
  // Determine availability type of slot - only used in the Face to Face to change the booking button colour
  const founditem = props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 13) === currentDate + thisHour.substring(0, 2));
  // console.log('Found Item:', founditem)
  return founditem.availabilityType;
}

function getBookingTypeForTimeBlockMinutes(props, thisHour, currentDate) {
  // Determine bookingType based on availability type of slot - only used in Face to Face bookings
  const founditem = props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 13) === currentDate + thisHour.substring(0, 2));
  //
  if (founditem.availabilityType === "NthQLDPHNFacetoFace") {
    return "FACE";
  } else {
    return props.bookingType ?? "VIDEO";
  }
}

function getBookingTypeForTimeBlock(props, thisHour, currentDate) {
  // Determine bookingType based on availability type of slot - only used in Face to Face bookings
  const founditem = props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 13) === currentDate + thisHour.substring(0, 2));

  //
  if (founditem.availabilityType === "NthQLDPHNFacetoFace") {
    return "FACE";
  } else {
    return props.bookingType ?? "VIDEO";
  }
}

function BookingDay(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      padding: 4,
    },
    hourItem: {
      borderBottom: "solid 1px silver",
      textAlign: "left",
    },
    slotItem: {
      backgroundColor: "rgb(254, 255, 204)",
      borderBottom: "solid 1px yellow",
      textAlign: "left",
    },
    dayHeading: {
      borderBottom: "solid 1px silver",
      fontWeight: 600,
      fontSize: 14,
      minHeight: 45,
    },
  }));

  const classes = useStyles();
  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var hours = [
    "06:00:00",
    "07:00:00",
    "08:00:00",
    "09:00:00",
    "10:00:00",
    "11:00:00",
    "12:00:00",
    "13:00:00",
    "14:00:00",
    "15:00:00",
    "16:00:00",
    "17:00:00",
    "18:00:00",
    "19:00:00",
    "20:00:00",
    "21:00:00",
    "22:00:00",
  ];

  var startHour = 6;
  var endHour = 22;
  // Create fifteen minute intervals
  var min15 = [];
  for (var h = startHour; h <= endHour; h++) {
    for (var m = 0; m < 60; m += 15) {
      var hourStr = h.toString().padStart(2, "0");
      var minuteStr = m.toString().padStart(2, "0");
      min15.push(`${hourStr}:${minuteStr}`);
    }
  }
  // Create 30 minute intervals
  var min30 = [];
  for (var h30 = startHour; h30 <= endHour; h30++) {
    for (var m30 = 0; m30 < 60; m30 += 30) {
      var hour30Str = h30.toString().padStart(2, "0");
      var minute30Str = m30.toString().padStart(2, "0");
      min30.push(`${hour30Str}:${minute30Str}`);
    }
  }

  var currentDate =
    props.day.getFullYear() +
    "-" +
    (props.day.getMonth() + 1 < 10 ? "0" + (props.day.getMonth() + 1) : props.day.getMonth() + 1) +
    "-" +
    (props.day.getDate() < 10 ? "0" + props.day.getDate() : props.day.getDate()) +
    "T";

  var today = new Date();
  var isToday = today.toDateString() === props.day.toDateString();
  var twoDaysInFuture = new Date();
  var durationType = "60";
  twoDaysInFuture.setHours(twoDaysInFuture.getHours() + 48);

  if (props.specialistType === "centralisedservice" && props.sessionType) {
    switch (props.sessionType) {
      case "P0101":
        // Handle P0101 session type
        durationType = "60";
        break;
      case "P0201":
        // Handle P0201 session type
        durationType = "60";
        break;
      case "P0102":
        // Handle P0102 session type
        durationType = "60";
        break;
      case "P0202":
        // Handle P0202 session type
        durationType = "60";
        break;
      case "P0103":
        // Handle P0103 session type
        durationType = "15";
        break;
      case "P0203":
        // Handle P0203 session type
        durationType = "15";
        break;
      case "P0304":
        // Handle P0304 session type
        durationType = "60";
        break;
      case "P0305":
        // Handle P0305 session type
        durationType = "60";
        break;
      case "P0306":
        // Handle P0306 session type
        durationType = "15";
        break;
      case "P0107":
        // Handle P0107 session type
        durationType = "15";
        break;
      case "P0207":
        // Handle P0207 session type
        durationType = "15";
        break;
      case "S0108":
        // Handle S0108 session type
        durationType = "15";
        break;
      case "S0208":
        // Handle S0208 session type
        durationType = "15";
        break;
      case "S0309":
        // Handle S0309 session type
        durationType = "15";
        break;
      default:
        durationType = "60";
    }
  }

  //
  // console.log(props.matchingAvailability.find(timeblock => timeblock.fromDate.toString() === (currentDate + '07:00')));

  return (
    <div className={classes.root}>
      <Grid container direction="column" spacing={1}>
        <Grid item xs className={classes.dayHeading}>
          <div className="bookingsDayHeader">
            <p className={isToday ? "bookingsDayNameToday" : "bookingsDayName"}>{days[props.day.getDay()]}</p>
            <div className={isToday ? "bookingsDayNumberToday" : "bookingsDayNumber"}>{props.day.getDate()}</div>
          </div>
        </Grid>

        {durationType === "60"
          ? hours.map((thisHour) =>
              props.matchingAvailability ? (
                props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 13) === currentDate + thisHour.substring(0, 2)) ? (
                  <Grid
                    item
                    xs
                    className={classes.slotItem}
                    key={getActualStartTime(props, thisHour, currentDate)}
                    onClick={() =>
                      props.startNewBooking({
                        mode: props.mode,
                        day: currentDate,
                        hour: getActualStartTime(props, thisHour, currentDate),
                        psychologistid: props.currentPsychologistID,
                        paymentType: props.paymentType,
                        bookingType: getBookingTypeForTimeBlockMinutes(props, thisHour, currentDate),
                        clientID: props.clientID,
                        duration: durationType,
                        bookingLocation: props.bookingLocation,
                        sessionType: props.sessionType,
                        specialistType: props.specialistType,
                      })
                    }
                  >
                    <Button
                      size="sm"
                      style={{
                        width: "100%",
                        backgroundColor: getAvailabilityTypeForTimeBlock(props, thisHour, currentDate) === "NthQLDPHNFacetoFace" ? "#ffa384" : "#384ad7",
                      }}
                    >
                      {getActualStartTimeDisplay(props, thisHour, currentDate)}
                    </Button>
                  </Grid>
                ) : (
                  <Grid item xs className={classes.hourItem} key={thisHour.substring(0, 5)}>
                    <p>{thisHour.substring(0, 5)}</p>
                  </Grid>
                )
              ) : (
                <Grid item xs className={classes.hourItem}>
                  <p>{thisHour.substring(0, 5)}</p>
                </Grid>
              ),
            )
          : null}

        {durationType === "15"
          ? min15.map((thismin15) =>
              props.matchingAvailability ? (
                props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 16) === currentDate + thismin15.substring(0, 5)) ? (
                  <>
                    <Grid
                      item
                      xs
                      className={classes.slotItem}
                      key={getActualStartTimeMinutes(props, thismin15, currentDate)}
                      onClick={() =>
                        props.startNewBooking({
                          mode: props.mode,
                          day: currentDate,
                          hour: getActualStartTimeMinutes(props, thismin15, currentDate),
                          psychologistid: props.currentPsychologistID,
                          paymentType: props.paymentType,
                          bookingType: getBookingTypeForTimeBlockMinutes(props, thismin15, currentDate),
                          clientID: props.clientID,
                          duration: durationType,
                          bookingLocation: props.bookingLocation,
                          sessionType: props.sessionType,
                          specialistType: props.specialistType,
                        })
                      }
                    >
                      <Button
                        size="sm"
                        style={{
                          width: "100%",
                          backgroundColor:
                            getAvailabilityTypeForTimeBlockMinutes(props, thismin15, currentDate) === "NthQLDPHNFacetoFace" ? "#ffa384" : "#384ad7",
                        }}
                      >
                        {getActualStartTimeDisplayMinutes(props, thismin15, currentDate)}
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs className={classes.hourItem} key={thismin15.substring(0, 5)}>
                    <p>{thismin15.substring(0, 5)}</p>
                  </Grid>
                )
              ) : (
                <Grid item xs className={classes.hourItem}>
                  <p>{thismin15.substring(0, 5)}</p>
                </Grid>
              ),
            )
          : null}

        {durationType === "30"
          ? min30.map((thismin30) =>
              props.matchingAvailability ? (
                props.matchingAvailability.find((timeblock) => timeblock.fromDate.toString().substring(0, 16) === currentDate + thismin30.substring(0, 5)) ? (
                  <Grid
                    item
                    xs
                    className={classes.slotItem}
                    key={getActualStartTimeMinutes(props, thismin30, currentDate)}
                    onClick={() =>
                      props.startNewBooking({
                        mode: props.mode,
                        day: currentDate,
                        hour: getActualStartTimeMinutes(props, thismin30, currentDate),
                        psychologistid: props.currentPsychologistID,
                        paymentType: props.paymentType,
                        bookingType: getBookingTypeForTimeBlock(props, thismin30, currentDate),
                        clientID: props.clientID,
                        duration: durationType,
                        bookingLocation: props.bookingLocation,
                        sessionType: props.sessionType,
                        specialistType: props.specialistType,
                      })
                    }
                  >
                    <Button
                      size="sm"
                      style={{
                        width: "100%",
                        backgroundColor:
                          getAvailabilityTypeForTimeBlockMinutes(props, thismin30, currentDate) === "NthQLDPHNFacetoFace" ? "#ffa384" : "#384ad7",
                      }}
                    >
                      {getActualStartTimeDisplayMinutes(props, thismin30, currentDate)}
                    </Button>
                  </Grid>
                ) : (
                  <Grid item xs className={classes.hourItem} key={thismin30.substring(0, 5)}>
                    <p>{thismin30.substring(0, 5)}</p>
                  </Grid>
                )
              ) : (
                <Grid item xs className={classes.hourItem}>
                  <p>{thismin30.substring(0, 5)}</p>
                </Grid>
              ),
            )
          : null}
      </Grid>
    </div>
  );
}
